"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuContext = exports.MenuContext = void 0;
var _react = require("react");
var noop = function noop() {};
var MenuContext = /*#__PURE__*/(0, _react.createContext)({
  element: 'a'
});
exports.MenuContext = MenuContext;
var SubMenuContext = /*#__PURE__*/(0, _react.createContext)({
  inSubMenu: false,
  onSelectedChange: noop
});
exports.SubMenuContext = SubMenuContext;